<template>
  <div>
    <div class="ipv6">
      <el-input
        :id="idPrefix + startIndex"
        ref="ip1"
        v-model="ip1"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(1, $event)"
        @mouseup.native="inputLimit(1, null)"
        @input="inputLimit(1, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">:</span>
      <el-input
        :id="idPrefix + (startIndex + 1)"
        ref="ip2"
        v-model="ip2"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(2, $event)"
        @mouseup.native="inputLimit(2, null)"
        @input="inputLimit(2, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">:</span>
      <el-input
        :id="idPrefix + (startIndex + 2)"
        ref="ip3"
        v-model="ip3"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(3, $event)"
        @mouseup.native="inputLimit(3, null)"
        @input="inputLimit(3, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">:</span>
      <el-input
        :id="idPrefix + (startIndex + 3)"
        ref="ip4"
        v-model="ip4"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(4, $event)"
        @mouseup.native="inputLimit(4, null)"
        @input="inputLimit(4, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">:</span>
      <el-input
        :id="idPrefix + (startIndex + 4)"
        ref="ip5"
        v-model="ip5"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(5, $event)"
        @mouseup.native="inputLimit(5, null)"
        @input="inputLimit(5, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">:</span>
      <el-input
        :id="idPrefix + (startIndex + 5)"
        ref="ip6"
        v-model="ip6"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(6, $event)"
        @mouseup.native="inputLimit(6, null)"
        @input="inputLimit(6, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">:</span>
      <el-input
        :id="idPrefix + (startIndex + 6)"
        ref="ip7"
        v-model="ip7"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(7, $event)"
        @mouseup.native="inputLimit(7, null)"
        @input="inputLimit(7, null)"
      />
      <span class="dot" :class="disabled && 'disabled'">:</span>
      <el-input
        :id="idPrefix + (startIndex + 7)"
        ref="ip8"
        v-model="ip8"
        size="small"
        maxlength="4"
        :disabled="disabled"
        @keyup.native="inputLimit(8, $event)"
        @mouseup.native="inputLimit(8, null)"
        @input="inputLimit(8, null)"
      />
      <span v-if="hasPrefixLen" class="dot" :class="disabled && 'disabled'"> / </span>
      <el-input
        v-if="hasPrefixLen"
        :id="prefixLenId"
        ref="prefix"
        v-model="len"
        size="small"
        maxlength="3"
        :disabled="disabled"
        @keyup.native="changePrefixLen()"
        @mouseup.native="changePrefixLen()"
        @input="changePrefixLen()"
      />
    </div>
  </div>
</template>
<script>
import { logWithPrefix } from "@/plugins/logging";
const log = logWithPrefix("[components/elements/ipAddress.vue]");
export default {
  props: {
    idPrefix: {
      type: String,
      default: "ipv6",
    },
    startIndex: {
      type: Number,
      default: 1,
    },
    config: {
      type: String,
      default: "",
    },
    limit: {
      type: String,
      default: "",
    },
    defaultValue: {
      type: String,
      default: ":::::::",
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    prefixLenId: {
      type: String,
      default: "prefixLen",
    },
    hasPrefixLen: {
      type: Boolean,
      default: false,
    },
    prefixLen: {
      type: String,
      default: "64",
    },
  },
  data() {
    return {
      ip1: "",
      ip2: "",
      ip3: "",
      ip4: "",
      ip5: "",
      ip6: "",
      ip7: "",
      ip8: "",
      len: "64",
    };
  },
  watch: {
    config: {
      handler() {
        if (this.config) {
          const arr = this.config.split(":");
          if (arr.length) {
            this.ip1 = arr[0] || "";
            this.ip2 = arr[1] || "";
            this.ip3 = arr[2] || "";
            this.ip4 = arr[3] || "";
            this.ip5 = arr[4] || "";
            this.ip6 = arr[5] || "";
            this.ip7 = arr[6] || "";
            this.ip8 = arr[7] || "";
            return;
          }
        }
        const defaultArr = this.defaultValue.split(":");
        this.ip1 = defaultArr[0] || "";
        this.ip2 = defaultArr[1] || "";
        this.ip3 = defaultArr[2] || "";
        this.ip4 = defaultArr[3] || "";
        this.ip5 = defaultArr[4] || "";
        this.ip6 = defaultArr[5] || "";
        this.ip7 = defaultArr[6] || "";
        this.ip8 = defaultArr[7] || "";
      },
      immediate: true,
    },
    prefixLen: {
      handler() {
        this.len = this.prefixLen;
        this.changePrefixLen();
      },
      immediate: true,
    },
  },
  methods: {
    change() {
      const ip = [
        this.ip1,
        this.ip2,
        this.ip3,
        this.ip4,
        this.ip5,
        this.ip6,
        this.ip7,
        this.ip8,
      ].join(":");
      this.$emit("update:config", ip === ":::::::" ? "" : ip);
      this.$emit("change");
    },
    inputLimit(idx, event) {
      log(event);
      const nexRefName = "ip" + (idx + 1);
      let val = this["ip" + idx];
      let lastChar = "";
      if (event) {
        lastChar = event.key;
      } else if (val.length) {
        lastChar = val[val.length - 1];
      }
      log("lastChar: " + lastChar);
      const hex = /([a-f0-9]*)/;
      const match = hex.exec(this["ip" + idx]);

      this["ip" + idx] = match ? match[0] : "";
      if (idx !== 8) {
        if (lastChar === ";" && this["ip" + idx] !== "") {
          log("ip" + (idx + 1), this.$refs["ip" + (idx + 1)]);
          this.$refs[nexRefName].select();
          this.$refs[nexRefName].focus();
        } else if (event && this["ip" + idx].length == 4) {
          this.$refs[nexRefName].select();
          this.$refs[nexRefName].focus();
        }
      }
      const reg = /^([0-9a-fA-F]{1,4})$/;
      val = this["ip" + idx];
      if (!reg.test(val)) {
        const match = val.match(/([0-9a-fA-F])/);
        if (match) {
          this["ip" + idx] = match[0];
        } else {
          this["ip" + idx] = "";
        }
      }
      this.change();
    },
    changePrefixLen() {
      if (this.hasPrefixLen) {
        this.len = this.len.replace(/\D+/, "");
        this.$emit("update:prefixLen", this.len);
      }
    },
  },
};
</script>
<style lang="scss">
@import "~@/styles/variables.scss";
.ipv6 {
  .el-input {
    width: $formInputFontSize * 0.67 * 4 + $formInputPaddingLeftRight;
  }
  .disabled {
    color: $formGrayOutColor;
  }
}
.orbi.gui-2-1 {
  .main-form .ipv6 .el-input {
    width: 56px;
  }
}
</style>
